import { Modal, Spin } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { Server } from '@wajeez-web/core/api-base';
import { WajeezMultilingualFormBuilder } from '@wajeez-web/components/form-builder';
import {
  useCreateAuthorMultilingual,
  useEditAuthorMultilingual,
  useGetAuthorByIdMultilingual,
} from '@wajeez-web/components/helpers';
import { Languages } from '@wajeez-web/core/utils';

const AuthorsModalComponent = ({
  isOpen,
  onClose,
  onSubmit,
}: CommonModalProps<Server.CreateAuthorV2Input>) => {
  const authorByIdMultilingualState = useGetAuthorByIdMultilingual();

  return (
    <Modal
      title="Author"
      withScroll={true}
      open={isOpen}
      onClose={onClose}
      fontClassName="font-[Tajawal]"
    >
      {authorByIdMultilingualState.status === 'loading' ? (
        <div className="h-[400px] flex justify-center items-center">
          <Spin />
        </div>
      ) : (
        <div className="pb-24">
          {onSubmit && <AuthorForm onSubmit={onSubmit} onCancel={onClose} />}
        </div>
      )}
    </Modal>
  );
};

export default AuthorsModalComponent;

interface AuthorFormProps {
  onSubmit: (
    props: Server.CreateAuthorV2Input | undefined
  ) => void | Promise<void>;
  onCancel: () => void;
}

export const AuthorForm = ({ onSubmit, onCancel }: AuthorFormProps) => {
  const authorByIdMultilingualState = useGetAuthorByIdMultilingual();
  const createAuthorMultilingualState = useCreateAuthorMultilingual();
  const editAuthorMultilingualState = useEditAuthorMultilingual();

  return (
    <div>
      <WajeezMultilingualFormBuilder<Server.CreateAuthorV2Input>
        isUpdate={
          createAuthorMultilingualState.status === 'loading' ||
          editAuthorMultilingualState.status === 'loading'
        }
        hasToggleButton={true}
        onSubmit={onSubmit}
        onCancel={onCancel}
        formValues={
          authorByIdMultilingualState.data
            ? authorByIdMultilingualState.data
            : { profiles: [{ languageId: Languages.AR }] }
        }
        rows={{
          originalName: {
            order: 300,
            label: 'Original Name',
            placeHolder: 'Original Name',
            required: true,
            fieldType: Server.FieldType.Text,
            fieldOptions: {},
          },
          imageReference: {
            order: 400,
            label: 'Image Reference',
            placeHolder: 'Image Reference',
            required: false,
            fieldType: Server.FieldType.UploadImage,
            fieldOptions: {},
          },
        }}
        profileRows={{
          name: {
            order: 100,
            label: 'Name',
            placeHolder: 'Name',
            required: true,
            fieldType: Server.FieldType.Text,
            fieldOptions: {},
          },
          about: {
            order: 200,
            label: 'About',
            placeHolder: 'About',
            required: false,
            fieldType: Server.FieldType.TineMCE,
            fieldOptions: {
              minLength: 2,
            },
          },
        }}
      />
    </div>
  );
};
